import { AiSingleChoiceGenerationButton } from './AiSingleChoiceGenerationButton';
import { AiSingleOptionGeneratingOverlay } from './AiSingleOptionGeneratingOverlay';

export const AiSingleChoiceGeneration = {
  Button: AiSingleChoiceGenerationButton,
  Overlay: AiSingleOptionGeneratingOverlay,
};
